export var VERSION = '1.12.2';
//# sourceMappingURL=version.js.map